export default __webpack_public_path__ + "static/media/experience.c50c576a.svg";